<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-public-image`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4a2 2 0 00-2 2v35.5a2 2 0 002 2h38a2 2 0 002-2v-31a2 2 0 00-2-2H21V6a2 2 0 00-2-2H5zm2 12V8h10v4.5h24V16H7zm0 4v19.5h34V20H7z"/></svg>
</template>
<script>

export default {
  name: 'IconPublicImage',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
